import { getLoggerService } from '@/modules/logger/infrastructure/loggerService';
export class IntercomService {
    constructor({ intercomAppID }) {
        if (!intercomAppID) {
            console.warn('Intercom configuration is missing required parameters.');
            this.intercomAppID = '';
            this.isBrowser = false;
            return;
        }
        this.intercomAppID = intercomAppID;
        this.isBrowser = typeof window !== 'undefined';
    }
    validateEnvironment() {
        if (!this.isBrowser) {
            console.warn('Intercom should not be initialized on the server.');
            return false;
        }
        if (!window?.Intercom) {
            console.warn('Intercom is not loaded on the page.');
            return false;
        }
        return true;
    }
    async getUserHash(userId) {
        try {
            const response = await fetch(`/intercom_sign?userId=${userId}`);
            if (!response.ok)
                throw new Error('Failed to sign Intercom hash');
            const { user_hash: userHash } = await response.json();
            return userHash;
        }
        catch (error) {
            console.error('Error getting Intercom hash:', error);
            return null;
        }
    }
    getBaseConfig() {
        return {
            api_base: 'https://api-iam.intercom.io',
            app_id: this.intercomAppID,
        };
    }
    async boot({ email, userId }) {
        try {
            if (!this.validateEnvironment())
                return;
            const intercomConfig = this.getBaseConfig();
            if (email && userId) {
                const userHash = await this.getUserHash(userId);
                if (userHash) {
                    Object.assign(intercomConfig, {
                        user_id: userId,
                        email,
                        user_hash: userHash,
                    });
                }
            }
            window.Intercom('boot', intercomConfig);
            this.update();
        }
        catch (error) {
            getLoggerService().logger.error('Intercom error', { error });
            console.error('Error booting Intercom:', error);
        }
    }
    update() {
        try {
            if (!this.validateEnvironment())
                return;
            window.Intercom('update', {
                hide_default_launcher: false,
            });
        }
        catch (error) {
            getLoggerService().logger.error('Intercom error', { error });
            console.error('Error updating Intercom:', error);
        }
    }
}
